export default "__VITE_ASSET__yCXoDRXX__"